import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog } from '@mui/material';
import { Circles } from 'react-loader-spinner';
import Pagination from './Pagination';
import Addfabric from './Addfabric';
import ProductDetails1 from './ProductDetails1';
import { deleteFabricData, getFabricData, normalizeFabricRecord } from '../api';
import Header from '../components/Header';
import './CategoryPage.css';
import './FabricGallery.css';

export const FabricGallery = () => {
  const navigate = useNavigate();
  const [products1, setProducts1] = useState([]);
  const [productDetails1, setProductDetails1] = useState();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [productEditOpen, setProductEditOpen] = useState(false);
  const [postsPerPage] = useState(12);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [selectedFabricType, setSelectedFabricType] = useState('all');

  const normalizeFabricType = (value) =>
    String(value || '').trim().toLowerCase();

  const getProducts = async () => {
    try {
      setLoading(true);
      const response = await getFabricData();
      const fabrics = response?.data ?? response?.fabrics ?? response?.fabric ?? response;
      const fabricList = Array.isArray(fabrics) ? fabrics : fabrics ? [fabrics] : [];

      const productsArray = fabricList.map((item) => normalizeFabricRecord(item));

      setProducts1(productsArray);
    } catch (error) {
      console.error('Error fetching fabrics: ', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProducts();
  }, []);

  const fabricTypes = useMemo(() => {
    const values = products1
      .map((item) => item.fabrictype)
      .filter(Boolean)
      .map(normalizeFabricType);

    return ['all', ...new Set(values)];
  }, [products1]);

  const filteredProducts = useMemo(() => {
    if (selectedFabricType === 'all') {
      return products1;
    }

    return products1.filter(
      (item) => normalizeFabricType(item.fabrictype) === selectedFabricType
    );
  }, [products1, selectedFabricType]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedFabricType]);

  const totalItemCount = filteredProducts.length;
  const lastItemIndex = currentPage * postsPerPage;
  const firstItemIndex = lastItemIndex - postsPerPage;
  const currentItems = filteredProducts.slice(firstItemIndex, lastItemIndex);
  const shouldDisplayPagination = filteredProducts.length > postsPerPage;

  const handleDialogToClose = () => {
    setDialogOpen(false);
  };

  const handleOnclickOfProduct1 = async (productDetails) => {
    const fabricId = productDetails?.fabric_id || productDetails?.id || productDetails?.ID;
    setDialogOpen(true);
    setProductDetails1(productDetails);

    if (!fabricId) {
      return;
    }

    try {
      const detailResponse = await getFabricData(fabricId);
      const normalizedDetail = normalizeFabricRecord(detailResponse);
      setProductDetails1(normalizedDetail);
    } catch (error) {
      console.error('Error fetching fabric by id:', error);
    }
  };

  const handleEditProduct = () => {
    setDialogOpen(false);
    setProductEditOpen(true);
  };

  const handleDeleteProduct = async () => {
    const fabricId = productDetails1?.fabric_id || productDetails1?.id;

    if (!fabricId) {
      window.alert('Fabric id is missing.');
      return;
    }

    const isConfirmed = window.confirm('Are you sure you want to delete this fabric?');
    if (!isConfirmed) {
      return;
    }

    try {
      await deleteFabricData(fabricId);
      setProducts1((prev) =>
        prev.filter((item) => String(item.fabric_id || item.id || item.record_group_id) !== String(fabricId))
      );
      setDialogOpen(false);
      setProductDetails1(undefined);
    } catch (error) {
      window.alert(`Error deleting fabric: ${error.message}`);
    }
  };

  const handleFabricUpdated = async () => {
    await getProducts();

    const fabricId = productDetails1?.fabric_id || productDetails1?.id || productDetails1?.ID;
    if (!fabricId) {
      return;
    }

    try {
      const detailResponse = await getFabricData(fabricId);
      const normalizedDetail = normalizeFabricRecord(detailResponse);
      setProductDetails1(normalizedDetail);
    } catch (error) {
      console.error('Error refreshing fabric detail:', error);
    }
  };

  const handleFilterSelect = (type) => {
    setSelectedFabricType(type);
  };

  return (
    <React.Fragment>
      <Header />
      <Dialog
        onClose={handleDialogToClose}
        open={dialogOpen}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '70%',
            overflowX: 'scroll',
            overflowY: 'scroll',
            scrollBehavior: 'auto',
          },
        }}
      >
        {productDetails1 !== undefined && productDetails1 !== null ? (
          <ProductDetails1
            productDetails1={productDetails1}
            handleEditProduct={handleEditProduct}
            handleDeleteProduct={handleDeleteProduct}
            onFabricUpdated={handleFabricUpdated}
          />
        ) : null}
      </Dialog>

      {productEditOpen ? (
        <Addfabric
          productDetails1={productDetails1}
          isFabricEdited
          onFabricSaved={async () => {
            await getProducts();
            setProductEditOpen(false);
            setDialogOpen(false);
            setProductDetails1(undefined);
          }}
        />
      ) : (
        <div className="fabric-gallery-page">
          <div className="category-header fabric-category-header">
            <div className="back-icon_category" onClick={() => navigate(-1)}>
              &lt; Back
            </div>
            <h1>Fabric's Wear</h1>
            <h2 className="total">Total Items: {totalItemCount}</h2>
          </div>

          <div className="fabric-type-buttons">
            <label htmlFor="fabric-type-filter" className="fabric-type-label">
              Fabrictype
            </label>
            <select
              id="fabric-type-filter"
              value={selectedFabricType}
              onChange={(e) => handleFilterSelect(e.target.value)}
              className="fabric-type-select"
            >
              <option value="all">Show All</option>
              {fabricTypes
                .filter((type) => type !== 'all')
                .map((type) => (
                  <option key={type} value={type}>
                    {type.toUpperCase()}
                  </option>
                ))}
            </select>
          </div>

          <div className="fabric-products-grid">
            {loading ? (
              <div className="fabric-loading">
                <Circles height={72} width={72} color="#007bff" ariaLabel="loading" />
              </div>
            ) : currentItems.length > 0 ? (
              currentItems.map((item) => {
                const primaryImage = item.imageUrls?.[0] || item.imageItems?.[0]?.url || '';

                return (
                  <div
                    key={item.ID}
                    className="fabric-card"
                    onClick={() => handleOnclickOfProduct1(item)}
                  >
                    <h2>{item.uniqueRecordId || item.ID || 'Fabric'}</h2>
                    <div className="fabric-image-wrap">
                      {primaryImage ? (
                        <img src={primaryImage} alt={item.fabricsup || 'Fabric'} />
                      ) : (
                        <div className="fabric-image-placeholder">Loading...</div>
                      )}
                    </div>
                    <div className="fabric-card-caption">
                      {item.fabrictype || item.fabricsup || 'No Fabric Type'}
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="fabric-empty-state">No fabrics found for this filter.</div>
            )}
          </div>

          {shouldDisplayPagination && (
            <Pagination
              totalPosts={filteredProducts.length}
              postsPerPage={postsPerPage}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default FabricGallery;
